
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkIssueItemsDialog extends _Ext.MFGTransItemEditorDialog<JobWorkIssueItemsRow> {
        protected getFormKey() { return JobWorkIssueItemsForm.formKey; }
        protected getLocalTextPrefix() { return JobWorkIssueItemsRow.localTextPrefix; }
        protected getNameProperty() { return JobWorkIssueItemsRow.nameProperty; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false; 
            return opt;
        }
        public departmentid: number;
        public form = new JobWorkIssueItemsForm(this.idPrefix);
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initMFGBOMEditor(this, this.form.BOMDetails, Config);
            q.initDetailEditor(this, this.form.NewBOMDetails, Config);
            q.hideCategorylinks(this.element);
            q.SetCategoryFourColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.ProductCode);
            q.SetCategoryFullWidth(this.form.BOMDetails);

            q.setTextRightAlign(this.form.FromWeight);
            q.setTextRightAlign(this.form.FromPieces);
            q.setTextRightAlign(this.form.FromNetWeight);
            q.setTextRightAlign(this.form.PureWeight);
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.NewBOMDetails);
            q.hideEditorToolbar(this.form.BOMDetails);
            q.HideCategoryLable(this.element);
             
            this.form.BagNo.changeSelect2(e => {

                if (this.form.FromDeptId.value == "" || this.form.FromDeptId.value == undefined) {
                    q.alert('Warning', 'Please select Department to proceed', true);
                    return;
                } else {
                    this.form.BOMDetails.cleardata();
                    let workorderdetails: WIPMovementRow;
                    WIPMovementSelectService.List(
                        { BagNo: this.form.BagNo.value, DepartmentId: parseInt(this.form.FromDeptId.value),PartyId:0 },
                        response => workorderdetails = response.Entities[0], { async: false }
                    );
                    let bomdetails: WIPTransactionRow[];
                    WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });


                    this.form.DepartmentId.value = workorderdetails.DepartmentId.toString();
                    this.form.FromPieces.value = workorderdetails.Pieces;
                    this.form.ProductId.value = workorderdetails.ProductId.toString();
                    this.form.Line_No.value = workorderdetails.Line_No.toString();
                    this.form.AttributeId.value = workorderdetails.AttributeId.toString();
                    this.form.ProductCode.value = workorderdetails.ProductCode;
                    this.form.Attribute.value = workorderdetails.Attribute;
                    this.form.TransDate.value = workorderdetails.TransDate;
                    this.form.VoucherNo.value = workorderdetails.VoucherNo;
                    this.form.Purity.value = workorderdetails.Purity;
                    this.form.PureWeight.value = workorderdetails.PureWeight;
                    this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                    this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                    this.form.RefTransId.value = workorderdetails.TransId.toString();
                    this.form.RefTransItemId.value = workorderdetails.TransItemId.toString();
                    this.form.RefVoucherId.value = workorderdetails.RefVoucherId;
                    this.form.OrderTypeId.value = workorderdetails.OrderTypeId;
                    this.form.OrderTransId.value = workorderdetails.OrderId;
                    this.form.Parts.value = workorderdetails.Parts;
                    this.form.SubBagNo.value = workorderdetails.SubBagNo;
                    this.form.TreeId.value = workorderdetails.TreeId == null ? "0" : workorderdetails.TreeId.toString();
                    this.form.TreeItemId.value = workorderdetails.TreeItemId == null ? "0" : workorderdetails.TreeItemId.toString();
                    this.form.TreeNo.value = workorderdetails.TreeNo;
                    //this.form.OrderTransItemId.value = workorderdetails.Orde;
                    //this.form.UserId.value = workorderdetails.UserId;

                    if (workorderdetails.OrderTypeId == 16) {
                        let salesdetails: SalesOrder.SalesOrderRow;
                        SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: workorderdetails.OrderId }, response => salesdetails = response.Entity, { async: false });

                        this.form.OrderNo.value = salesdetails.VoucherNo;
                        this.form.CustomerName.value = salesdetails.LedgerName;

                    } else if (workorderdetails.OrderTypeId == 47) {

                        let posdetails: Retail.POSOrderRow;
                        Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: workorderdetails.OrderId }, response => posdetails = response.Entity, { async: false });
                        this.form.OrderNo.value = posdetails.VoucherNo;
                        this.form.CustomerName.value = posdetails.CustomerName;
                    }
                    //var maxdeptno = 0;
                    //for (var k = 0; k < bomdetails.length; k++) {
                    //    var deptno = bomdetails[k].DepartmentId;
                    //    maxdeptno = deptno;
                    //}
                    //bomdetails = bomdetails.filter(x => x.DepartmentId == maxdeptno); 

                    var newbomdetails = [];
                    for (var i = 0; i < bomdetails.length; i++) {
                        var value = bomdetails[i];

                        var newbom: JobWorkIssueBOMRow = {
                            AttributeId: value.AttributeId,
                            ItemTypeId: value.ItemTypeId,
                            CalcOnId: value.CalcOnId,
                            ProductCode: value.ProductCode,
                            Attribute: value.Attribute,
                            BomProductId: value.ProductId,
                            BagNo: value.BagNo,
                            ProductId: workorderdetails.ProductId,
                            FromDeptId: value.DepartmentId,
                            FromWorkerId: value.EmployeeId,
                            Pieces: value.Pieces,
                            Line_No: value.Line_No,
                            PureWeight: value.PureWeight,
                            Purity: value.Purity,
                            Weight: value.Weight,
                            RefTransId: value.TransId,
                            RefVoucherId: value.VoucherTypeId,
                            IsCustomerItem: value.IsCustomerItem
                        };
                        newbomdetails.push(newbom);
                    }
                    this.form.BOMDetails.setdata(newbomdetails);
                    this.form.NewBOMDetails.BOMProductIds = newbomdetails;
                    this.CalculateTotals();
                }

            });

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );


        }

        protected inplaceSearchClick(e: any): void {
           
            if (!this.isViewMode()) {
                var grid = WIPMovementSelectGrid;
                
                var filters: _Ext.SelectGridFilters = {
                    DepartmentId: parseInt(this.form.FromDeptId.value),
                    PartyId:0
                }
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters, Width: 800, height: 500
                });

                pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {
                    
                    let Item = selectedItems.shift();
                    if (Item != null) {

                        this.form.BagNo.value = Item.BagNo;
                        this.form.DepartmentId.value = Item.DepartmentId.toString();
                        this.form.FromPieces.value = Item.Pieces;
                        this.form.ProductId.value = Item.ProductId.toString();
                        this.form.Line_No.value = Item.Line_No.toString();
                        this.form.AttributeId.value = Item.AttributeId.toString();
                        this.form.ProductCode.value = Item.ProductCode;
                        this.form.Attribute.value = Item.Attribute;
                        this.form.TransDate.value = Item.TransDate;
                        this.form.VoucherNo.value = Item.VoucherNo;
                        this.form.FromNetWeight.value = Item.NetWeight;
                        this.form.FromWorkerId.value = Item.EmployeeId.toString();
                        this.form.Purity.value = Item.Purity;
                        this.form.PureWeight.value = Item.PureWeight;
                        this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                        this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                        this.form.RefTransId.value = Item.TransId.toString();
                        this.form.RefTransItemId.value = Item.TransItemId.toString();
                        this.form.RefVoucherId.value = Item.RefVoucherId;
                        this.form.OrderTypeId.value = Item.OrderTypeId;
                        this.form.OrderTransId.value = Item.OrderId;
                        this.form.OrderTransItemId.value = Item.RefTransItemId;

                        this.form.Parts.value = Item.Parts;
                        this.form.SubBagNo.value = Item.SubBagNo;
                        this.form.TreeId.value = Item.TreeId == null ? "0" : Item.TreeId.toString();
                        this.form.TreeItemId.value = Item.TreeItemId == null ? "0" : Item.TreeItemId.toString();
                        this.form.TreeNo.value = Item.TreeNo;
                         
                        if (Item.OrderTypeId == 16) {
                            let salesdetails: SalesOrder.SalesOrderRow;
                            SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: Item.OrderId }, response => salesdetails = response.Entity, { async: false });
                            this.form.OrderNo.value = salesdetails.VoucherNo;
                            this.form.CustomerName.value = salesdetails.LedgerName;

                        } else if (Item.OrderTypeId == 47) {

                            let posdetails: Retail.POSOrderRow;
                            Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: Item.OrderId }, response => posdetails = response.Entity, { async: false });
                            this.form.OrderNo.value = posdetails.VoucherNo;
                            this.form.CustomerName.value = posdetails.CustomerName;
                        }
                        let bomdetails:any[];
                        WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                        var newbomdetails = [];
                        for (var i = 0; i < bomdetails.length; i++) {
                            var value = bomdetails[i];

                            var newbom: JobWorkIssueBOMRow = {
                                AttributeId: value.AttributeId,
                                ItemTypeId: value.ItemTypeId,
                                CalcOnId: value.CalcOnId,
                                ProductCode: value.ProductCode,
                                Attribute: value.Attribute,
                                BomProductId: value.ProductId,
                                BagNo: value.BagNo,
                                ProductId: Item.ProductId,
                                FromDeptId: value.DepartmentId,
                                FromWorkerId: value.EmployeeId,
                                Pieces: value.Pieces,
                                Line_No: value.Line_No,
                                PureWeight: value.PureWeight,
                                Purity: value.Purity,
                                Weight: value.Weight,
                                RefTransId: value.TransId,
                                RefVoucherId: value.VoucherTypeId
                            };
                            newbomdetails.push(newbom);
                        }
                        this.form.BOMDetails.setdata(newbomdetails);
                        this.form.NewBOMDetails.bagno = Item.BagNo;
                        this.CalculateTotals();
                    }
                }
                pickerDialog.dialogOpen();

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

        public CalculateTotals() {
            var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
            for (var k of this.form.BOMDetails.getItems()) {

                if (k.ItemTypeId == 104) {
                    Wt += k.Weight;
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                    cts += k.Weight;
                    diapcs += k.Pieces
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                    gms += k.Weight;
                    clrpcs += k.Pieces;
                }

            }

            if (cts > 0)
                this.form.FromWeight.value = Wt + gms + (cts / 5);
        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var fromdeptid = parseInt(this.form.FromDeptId.value);
            var bomdetails = this.form.BOMDetails.getItems();
            for (var a = 1; a < bomdetails.length; a++) {
                bomdetails[a].FromDeptId = fromdeptid;
            }

            this.form.BOMDetails.setdata(bomdetails);
            return true;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ProductId.value != "") {
                this.form.NewBOMDetails.BOMProductIds = this.form.BOMDetails.getItems();
            }
        }
    }
}